import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useGetTariffsPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/tariffs/get-tariffs-paginated.form-validation';
import { GetTariffsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/tariffs/get-tariffs-paginated.model';
import { Controller, useFormContext } from 'react-hook-form';

import { EmspBoCpoFilterController } from '@app/feature/emsp-bo-cpo/emsp-bo-cpo-filter/emsp-bo-tariff-cpo-filter.controller';

import { EmspBoTariffCreatedAfterFilterController } from '../../emsp-bo-tariff-created-after-filter/emsp-bo-tariff-created-after-filter.controller';
import { EmspBoTariffCreatedBeforeFilterController } from '../../emsp-bo-tariff-created-before-filter/emsp-bo-tariff-created-before-filter.controller';
import { EmspBoTariffIdFilterController } from '../../emsp-bo-tariff-id-filter/emsp-bo-tariff-id-filter.controller';
import { EmspBoTariffUpdatedAfterFilterController } from '../../emsp-bo-tariff-updated-after-filter/emsp-bo-tariff-updated-after-filter.controller';
import { EmspBoTariffUpdatedBeforeFilterController } from '../../emsp-bo-tariff-updated-before-filter/emsp-bo-tariff-updated-before-filter.controller';

const EmspBoTariffListFilterFormStep1IdFragment = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  // const { t } = useTranslation();
  const { control } = useFormContext<GetTariffsPaginatedModel>();
  const { id } = useGetTariffsPaginatedFormValidation();

  // RENDER //////////////////////////////////////////////////////////////////

  return (
    <>
      <Controller
        name="id"
        control={control}
        rules={id}
        render={({ field /* , fieldState: { error } */ }) => {
          const value = Array.isArray(field.value)
            ? field.value.join(', ')
            : (field.value ?? '');

          return (
            <EmspBoTariffIdFilterController
              value={value}
              onChange={(e) => {
                field.onChange(e.target.value === '' ? '' : e.target.value);
              }}
            />
          );
        }}
      />
      <Divider />
    </>
  );
};

const EmspBoTariffListFilterFormStep1CpoIdFragment = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  // const { t } = useTranslation();
  const { control } = useFormContext<GetTariffsPaginatedModel>();
  const { cpoId } = useGetTariffsPaginatedFormValidation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <>
      <Controller
        name="cpoId"
        control={control}
        rules={cpoId}
        render={({ field /* , fieldState: { error } */ }) => {
          const values = [];

          if (Array.isArray(field.value)) {
            values.push(...field.value);
          } else if (field.value) {
            values.push(field.value);
          }

          return (
            <EmspBoCpoFilterController
              selectedItemIds={values}
              onChange={(value) => field.onChange(value)}
            />
          );
        }}
      />
      <Divider />
    </>
  );
};

const EmspBoTariffListFilterFormStep1CreatedAfterFragment =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    // const { t } = useTranslation();
    const { control } = useFormContext<GetTariffsPaginatedModel>();
    const { createdAfter } = useGetTariffsPaginatedFormValidation();

    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <>
        <Controller
          name="createdAfter"
          control={control}
          rules={createdAfter}
          render={({ field /* , fieldState: { error } */ }) => {
            return (
              <EmspBoTariffCreatedAfterFilterController
                selected={field.value ? new Date(field.value) : undefined}
                onSelect={(value) => field.onChange(value)}
              />
            );
          }}
        />
        <Divider />
      </>
    );
  };

const EmspBoTariffListFilterFormStep1CreatedBeforeFragment =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    // const { t } = useTranslation();
    const { control } = useFormContext<GetTariffsPaginatedModel>();
    const { createdBefore } = useGetTariffsPaginatedFormValidation();

    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <>
        <Controller
          name="createdBefore"
          control={control}
          rules={createdBefore}
          render={({ field /* , fieldState: { error } */ }) => {
            return (
              <EmspBoTariffCreatedBeforeFilterController
                selected={field.value ? new Date(field.value) : undefined}
                onSelect={(value) => field.onChange(value)}
              />
            );
          }}
        />
        <Divider />
      </>
    );
  };

const EmspBoTariffListFilterFormStep1UpdatedAfterFragment =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    // const { t } = useTranslation();
    const { control } = useFormContext<GetTariffsPaginatedModel>();
    const { updatedAfter } = useGetTariffsPaginatedFormValidation();

    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <>
        <Controller
          name="updatedAfter"
          control={control}
          rules={updatedAfter}
          render={({ field /* , fieldState: { error } */ }) => {
            return (
              <EmspBoTariffUpdatedAfterFilterController
                selected={field.value ? new Date(field.value) : undefined}
                onSelect={(value) => field.onChange(value)}
              />
            );
          }}
        />
        <Divider />
      </>
    );
  };

const EmspBoTariffListFilterFormStep1UpdatedBeforeFragment =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    // const { t } = useTranslation();
    const { control } = useFormContext<GetTariffsPaginatedModel>();
    const { updatedBefore } = useGetTariffsPaginatedFormValidation();

    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <Controller
        name="updatedBefore"
        control={control}
        rules={updatedBefore}
        render={({ field /* , fieldState: { error } */ }) => {
          return (
            <EmspBoTariffUpdatedBeforeFilterController
              selected={field.value ? new Date(field.value) : undefined}
              onSelect={(value) => field.onChange(value)}
            />
          );
        }}
      />
    );
  };

export const EmspBoTariffListFilterFormStep1Controller =
  (): React.JSX.Element => {
    return (
      <Stack
        direction="row"
        justifyContent="stretch"
        alignItems="stretch"
        flex={1}
        gap={GapEnum.M}>
        <Stack direction="column" flex={1} alignItems="stretch" gap={GapEnum.M}>
          <EmspBoTariffListFilterFormStep1CpoIdFragment />
          <EmspBoTariffListFilterFormStep1IdFragment />
          <EmspBoTariffListFilterFormStep1CreatedAfterFragment />
          <EmspBoTariffListFilterFormStep1CreatedBeforeFragment />
          <EmspBoTariffListFilterFormStep1UpdatedAfterFragment />
          <EmspBoTariffListFilterFormStep1UpdatedBeforeFragment />
        </Stack>
      </Stack>
    );
  };
